import { createAction } from 'redux-actions';
import Constants from 'taker/constants';

export const showError = createAction(Constants.SHOW_ERROR);
